module.exports = __webpack_public_path__ + "assets/ca9a22a89fdabe2cbabfda70b3d4a129.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/coordinator-logo.svg
 ** module id = 1772
 ** module chunks = 1
 **/